module.exports = __webpack_public_path__ + "static/img/logo31.a09b92c6.png";